import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import AgUsaImportModel from 'donor-elf-web/models/ag-usa-import';
import AbilitiesService from 'donor-elf-web/services/abilities';
import FundsService from 'donor-elf-web/services/funds-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface ImportAgUsaRouteModel {
  agUsaImport: AgUsaImportModel;
}

export default class ImportAgUsaRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel(transition: any) {
    if (this.abilities.noAbility('import_ag_usa')) {
      transition.abort();
      return;
    }
    this.navbarSettings.title = 'Import Gifts';
  }

  async model(): Promise<ImportAgUsaRouteModel> {
    let model = await this.store.findRecord(
      'ag-usa-import',
      this.fundsService.selectedFund!.id,
    );
    return {
      agUsaImport: model,
    };
  }
}
